"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// This file is generated via pbjs/pbts directly into dist
const validator_1 = require("./validator");
class NetworkError extends Error {
    constructor(cause, rpcName) {
        super(`network error on ${rpcName}: ${cause.message || cause}`);
        this.cause = cause;
        this.type = "network-error";
    }
}
exports.NetworkError = NetworkError;
class HTTPError extends Error {
    constructor(status, rpcName) {
        super(`http error on ${rpcName}: ${status}`);
        this.status = status;
        this.type = "http-error";
    }
}
exports.HTTPError = HTTPError;
class ValidationError extends Error {
    constructor(responseBody, rpcName) {
        super(`validation error on ${rpcName}`);
        this.errors = validator_1.proto.ValidationError.decode(responseBody);
        this.type = "validation-error";
    }
}
exports.ValidationError = ValidationError;
class AuthenticationError extends Error {
    constructor(rpcName) {
        super(`authentication error calling ${rpcName}`);
        this.type = "authentication-error";
    }
}
exports.AuthenticationError = AuthenticationError;
const validateStatus = (rpcName, props) => {
    if (props.statusCode === 422) {
        throw new ValidationError(props.body, rpcName);
    }
    else if (props.statusCode === 403) {
        throw new AuthenticationError(rpcName);
    }
    else if (props.statusCode >= 400) {
        throw new HTTPError(props.statusCode, rpcName);
    }
    return props;
};
const impl = (context) => (method, requestData, callback) => {
    const rpcName = method.__rpcName;
    if (!rpcName) {
        return callback(new Error("no service name!"));
    }
    context
        .prottpImpl(context, rpcName, requestData)
        .catch(err => {
        throw new NetworkError(err, rpcName);
    })
        .then(props => validateStatus(rpcName, props)) // throws error, caught below
        .then(({ body }) => callback(null, body), err => {
        if (context.onError == null ||
            ((err = context.onError(err)), err != null)) {
            callback(err);
        }
    });
};
exports.impl = impl;
const imprint = (o, path = []) => {
    if (typeof o === "object") {
        for (const pkgName in o) {
            const pkg = o[pkgName];
            const newPath = path.concat(pkgName);
            if (pkg.prototype && pkg.prototype.constructor) {
                const service = pkg.prototype;
                const pkgPath = newPath.join(".");
                Object.keys(service).forEach(rpcName => {
                    const rpc = service[rpcName];
                    if (typeof rpc === "function" && rpcName !== "constructor") {
                        rpcName = rpcName.slice(0, 1).toUpperCase() + rpcName.slice(1);
                        rpc.__rpcName = `${pkgPath}/${rpcName}`;
                    }
                });
            }
            else {
                imprint(pkg, newPath);
            }
        }
    }
};
exports.imprint = imprint;
const makeService = (service, context) => service.create(impl(context));
exports.makeService = makeService;
//# sourceMappingURL=index.js.map